import type { Drama } from '@/mocks/dramas';

export default function DisclaimerSection({ drama }: { drama: Drama }) {
  return (
    <section id="disclaimer" className="scroll-mt-28 pt-2">
      <div className="flex items-center gap-3 mb-5">
        <span className="font-label text-xs text-foreground-400">05</span>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
          片尾声明解读
        </h2>
      </div>

      <div className="relative p-6 md:p-8 rounded-lg bg-background-100 border border-background-300 overflow-hidden paper-noise">
        <span className="absolute top-5 right-5 hidden sm:flex items-center justify-center w-20 h-20 stamp-ring">
          <span className="font-heading text-[11px] leading-tight text-primary-600 text-center">
            已
            <br />
            归档
          </span>
        </span>
        <p className="font-label text-xs tracking-[0.2em] text-foreground-400 mb-3">
          DISCLAIMER · 原文
        </p>
        <blockquote className="font-heading text-base md:text-lg text-foreground-900 leading-loose pr-0 sm:pr-24">
          {drama.disclaimerRaw}
        </blockquote>
      </div>

      <div className="mt-6">
        <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-3 flex items-center gap-2">
          <i className="ri-book-open-line text-primary-600"></i>
          这段话该怎么读
        </h3>
        <p className="text-sm md:text-base text-foreground-600 leading-loose">
          {drama.disclaimerRead}
        </p>
      </div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="p-4 rounded-lg bg-background-100 border border-background-200">
          <p className="text-xs text-foreground-500 mb-1.5">声明强度</p>
          <p className="font-heading text-sm font-bold text-foreground-950">{drama.confirmLevel}</p>
          <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">
            按片方声明措辞与公开信源交叉判定
          </p>
        </div>
        <div className="p-4 rounded-lg bg-background-100 border border-background-200">
          <p className="text-xs text-foreground-500 mb-1.5">可对号入座程度</p>
          <p className="font-heading text-sm font-bold text-foreground-950">
            {drama.adaptationScore >= 80 ? '仍需谨慎' : '不建议对应具体个人'}
          </p>
          <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">
            剧中人物普遍经过化名与合并处理
          </p>
        </div>
        <div className="p-4 rounded-lg bg-background-100 border border-background-200">
          <p className="text-xs text-foreground-500 mb-1.5">建议观看方式</p>
          <p className="font-heading text-sm font-bold text-foreground-950">
            {drama.adaptationScore >= 78 ? '可作事件参考' : '宜作故事观看'}
          </p>
          <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">
            结合本页对照表判断，而非依赖宣传语
          </p>
        </div>
      </div>
    </section>
  );
}